// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyB8CKkKJMU7Ad3bjvpEkt9MxbLpLYk-tis',
    authDomain: 'snowrise-f68dc.firebaseapp.com',
    databaseURL: 'https://snowrise-f68dc.firebaseio.com',
    projectId: 'snowrise-f68dc',
    storageBucket: 'snowrise-f68dc.appspot.com',
    messagingSenderId: '795193295717'
  }
};



// WEBPACK FOOTER //
// /Software/Workspaces/snowrise/snowrise-console/src/environments/environment.ts